// Initialize mobile menu
(function() {
    // Mobile Menu Trigger
    var burger = document.querySelector('.gh-burger');
    if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.addEventListener('click', function() {
            var isOpen = document.body.classList.toggle('gh-head-open');
            burger.setAttribute('aria-expanded', String(isOpen));
        });
    }
})();


// Article share button: native share on mobile, copy URL fallback on desktop
(function() {
    var shareButtons = document.querySelectorAll('.gh-button-share');
    if (!shareButtons.length) {
        return;
    }

    function copyToClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }

        return new Promise(function(resolve, reject) {
            var textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            textArea.style.top = '-9999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand('copy') ? resolve() : reject(new Error('Copy failed'));
            } catch (err) {
                reject(err);
            }

            document.body.removeChild(textArea);
        });
    }

    shareButtons.forEach(function(button) {
        button.addEventListener('click', function(event) {
            event.preventDefault();

            var url = window.location.href.split('#')[0];
            var title = document.querySelector('.article-title') ? document.querySelector('.article-title').textContent.trim() : document.title;

            if (navigator.share) {
                navigator.share({
                    title: title,
                    url: url
                }).catch(function() {});
                return;
            }

            copyToClipboard(url).then(function() {
                var originalText = button.textContent;
                button.textContent = 'Link kopiert';
                button.classList.add('is-copied');

                window.setTimeout(function() {
                    button.textContent = originalText;
                    button.classList.remove('is-copied');
                }, 1800);
            }).catch(function() {
                window.prompt('Link kopieren:', url);
            });
        });
    });
})();
